import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledButtonArrowLeft,
  StyledButtonArrowRight,
  StyledIcon
} from './style';

import { Arrow, ArrowLeft } from '../../../../assets/images/index';

const ButtonArrowLeft = ({ className, onClick, onMouseEnter, color }) => (
  <StyledButtonArrowLeft
    className={className}
    onClick={onClick}
    onMouseEnter={onMouseEnter}
  >
    <StyledIcon
      className={className}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      color={color}
      svg={ArrowLeft}
    />
  </StyledButtonArrowLeft>
);

ButtonArrowLeft.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};
ButtonArrowLeft.defaultProps = {
  color: 'dark'
};

const ButtonArrowRight = ({ className, onClick, onMouseEnter, color }) => (
  <StyledButtonArrowRight
    className={className}
    onClick={onClick}
    onMouseEnter={onMouseEnter}
  >
    <StyledIcon
      className={className}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      color={color}
      svg={Arrow}
    />
  </StyledButtonArrowRight>
);

ButtonArrowRight.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

ButtonArrowRight.defaultProps = {
  color: 'dark'
};

export { ButtonArrowLeft, ButtonArrowRight };
